import { styled } from '@uhg-abyss/web/tools/styled';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';

export const CollapseCardHeaderStyle = {
  backgroundColor: 'white',
  borderRadius: 'unset',
  borderLeft: 'none',
  borderRight: 'none',
  boxShadow: 'none',
  color: '$core.color.brand.100',
  fontWeight: 'bold',
  fontSize: '25.63px',
  lineHeight: '32px',
  marginBottom: '$sm',
  minHeight: 'unset',
  padding: '0',
  '.abyss-card-root': {
    justifyContent: 'left',
  },
  '.abyss-card-title': {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
  },
  '@media (max-width: 744px)': {
    fontSize: '20.25px',
    lineHeight: '24px',
    paddingLeft: '$md',
    paddingRight: '$md',
    paddingTop: '$md',
    borderColor: '$core.color.neutral.20',
  },
};

export const CollapseSection = styled(Layout.Group, {
  '&.abyss-layout-group': {
    width: '100%',
    paddingLeft: '0',
    marginTop: '$sm',
    marginBottom: '$sm',
    display: 'block',
    marginRight: '0',
    '@media (max-width: 744px)': {
      display: 'block',
      width: '100%',
    },

    '& > div': {
      marginRight: '-4px',
    },
    '& .abyss-button-root': {
      width: '24px',
      height: '24px',
      fontSize: '24px',
      '& span': {
        padding: 0,
      },
    },
  },
});

export const TextContainer = styled('div', {
  maxWidth: '841px',
  fontWeight: '$medium',
  fontSize: '$lg',
  lineHeight: '24px',
  color: '$core.color.neutral.80',
  overflow: 'auto',
  marginBottom: '10px',
  '@media (max-width: 464px)': {
    maxWidth: '338px',
    fontSize: '$md',
    lineHeight: '20px',
    marginBottom: '0',
  },
});

export const StyledHeadingText = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '$lg',
    lineHeight: '24px',
    fontWeight: '500',
    color: '$core.color.neutral.80',

    '@media (max-width: 464px)': {
      height: '24px',
      fontSize: '$md',
      lineHeight: '20px',
      display: 'block',
      marginBottom: '12px',
    },
  },
});

export const StyledHeadingTextDate = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '$lg',
    lineHeight: '24px',
    fontWeight: '700',
    color: 'black',
    '@media (max-width: 464px)': {
      marginBottom: '2%',
      height: '24px',
      fontSize: '$md',
      fontWeight: '500',
      lineHeight: '20px',
      color: '$core.color.neutral.60',
    },
  },
});

export const StyledContentText = styled('p', {
  fontWeight: '500',
  fontSize: '$lg',
  color: '$core.color.neutral.80',
  lineHeight: '24px',
  marginBottom: '$md',
  '@media (max-width: 464px)': {
    height: '24px',
    fontSize: '$md',
    lineHeight: '20px',
  },
});

export const SectionContainer = styled('div', {
  borderWidth: '1px 0',
  borderStyle: 'solid',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  borderColor: '$cardBorder',
  marginRight: 0,
  padding: '$lg calc((100% - 1200px) / 2)',
  '@media (max-width: 1248px)': {
    padding: '$lg',
  },
  '@media (max-width: 744px)': {
    padding: '$md',
  },
});
export const HeadingContainer = styled('div', {
  width: '338px',
  height: '32px',
  fontWeight: 'bold',
  fontSize: '25.63px',
  lineHeight: '32px',
  color: '$core.color.brand.100',
  marginBottom: '12px',
  '@media (max-width: 464px)': {
    height: '24px',
    fontSize: '20.25px',
    lineHeight: '24px',
    marginBottom: 'initial',
  },
});
